




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Catalog {
    code: string;
}

@Component({ components: { SimpleText } })
export default class Code extends Vue {
    @Prop( { default: null }) public catalog !: Catalog;

    public static getNeededFields(): string[] {
        return [
            "catalog.code",
        ];
    }
}
